import { CONVERSATION_FEATURES } from "./features";

export const CONVERSATIONS_ROUTES = {
  area: "/conversations",
  /** `MeetingsPage` reads the tab from `?tab=` (meetings-page.tsx) — the Schedule tab is where a per-occurrence skip lives. */
  schedule: "/conversations?tab=schedule",
  conversation: (id: string) => `/conversations/${id}`,
  jobTab: (jobId: string) => `/jobs/${jobId}/conversations`,
  orgSettings: "/settings/notetaker",
  personalSettings: "/settings/my-conversations",
} as const;

export const MEETINGS_TABS = ["all", "schedule", "attention", "generators"] as const;
export type MeetingsTab = (typeof MEETINGS_TABS)[number];

/** Tabs in the Meetings toolbar and the mobile Meetings nav. Generators stays in `MEETINGS_TABS` for the URL contract, but is omitted while the feature is off. */
export function visibleMeetingsTabs(): readonly MeetingsTab[] {
  if (CONVERSATION_FEATURES.generators) return MEETINGS_TABS;
  return MEETINGS_TABS.filter((tab) => tab !== "generators");
}

/** Unknown or disabled tabs (including `?tab=generators` while the feature is off) land on All. */
export function resolveMeetingsTab(raw: string | null): MeetingsTab {
  if (!(MEETINGS_TABS as readonly string[]).includes(raw ?? "")) return "all";
  const tab = raw as MeetingsTab;
  if (!visibleMeetingsTabs().includes(tab)) return "all";
  return tab;
}
